export const stripNonNumbers = (myString) => {
    return myString.replace(/\D/g,'');
}

export const numberWithCommas = (aNumber) => {
    return aNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
